/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchCustomerAssessments(parameters) {
  const response = await $.soap({
    body: {
      SearchCustomerAssessments: {
        $xmlns: 'http://dla.mil/ems/bpm/assessment',
        CustomerAssessmentID: parameters.customerAssessmentID,
        TypeID: parameters.typeID,
        StatusID: parameters.statusID,
        StatusGroupID: parameters.statusGroupID,
        CustomerName: parameters.customerName,
        CRSName: parameters.crsName,
        RegionID: parameters.regionID,
        CommandName: parameters.commandName
      }
    },
    blueprintArrays: ['SearchCustomerAssessmentsResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      assessments: [
        '$..old.rowset.row',
        {
          id: '$.ID',
          typeID: '$.TypeID',
          type: '$.Type',
          statusID: '$.StatusID',
          externalAssessmentStatus: '$.ExternalAssessmentStatus',
          internalAssessmentStatus: '$.InternalAssessmentStatus',
          customerName: '$.CustomerName',
          crsOwnerName: '$.CRSOwnerName',
          regionID: '$.RegionID',
          regionCode: '$.RegionCode',
          submittedOn: '$.SubmittedOn',
          serviceBranchName: '$.ServiceBranchName',
          commandName: '$.CommandName',
          commandId: '$.CommandID'
        }
      ]
    }
  });
  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  return response;
}
